/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu, Jul 15th 2021, 9:53:14 pm
 *
 * *****************************************************
 */

import { useEffect, useCallback } from 'react';

import { useHistory, Switch, Route } from 'react-router-dom';

import { LOGOUT_KEY } from 'constants/local-storage';
import authRouteDefs from 'features/auth/routes/defs';
import { SIGN_IN } from 'features/auth/routes/paths';
import { ERROR_500 } from 'features/common/routes/paths';
import Page404 from 'features/common/views/pages/404';
import Page500 from 'features/common/views/pages/500';
import { loggedOut } from 'states/slices/auth';
import { useAppDispatch } from 'utils/hooks';
import { renderRoutes } from 'utils/routes';

const App = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  /**
   * Sync logout handler
   */
  const handleSyncLogoutSignal = useCallback(
    (e: StorageEvent) => {
      if (e.key === LOGOUT_KEY) {
        dispatch(loggedOut());
        history.push(SIGN_IN);
      }
    },
    [history, dispatch]
  );

  useEffect(() => {
    // Listen to sync logout signal
    // NOTE: The storage event fires when a storage area has been changed in the context of ANOTHER document.
    window.addEventListener('storage', handleSyncLogoutSignal);
    return (): void => {
      window.removeEventListener('storage', handleSyncLogoutSignal);
      localStorage.removeItem(LOGOUT_KEY);
    };
  }, [handleSyncLogoutSignal]);

  /**
   * An array containing all route definitions of our app
   */
  const routeDefs = [...authRouteDefs];

  return (
    <div id="wise">
      <Switch>
        {renderRoutes(routeDefs)}
        <Route exact path={ERROR_500} component={Page500} />
        <Route component={Page404} />
      </Switch>
    </div>
  );
};

export default App;
